<template>
<div class="custome-card">
    <GmapMap :options="{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            disableDefaultUi: false
        }" :center='center' map-type-id="roadmap" :zoom='zoom' style='width:100%;  height: 200px;'> </GmapMap>
    <div class="p-3">
        <div class="shift-top text-center">
            <img :src="image" class="business-logo" alt="business logo">
        </div>
        <div class="text-center b-details">
            <p class="font14">{{name}}</p>
            <button @click="handleClick" class="font12 btn btn-warning ">Show Services</button>
        </div>
    </div>

</div>
</template>

<script>

export default {
    name: 'service-card',
    props: ['center', 'zoom', 'services', 'image', 'name'],
    methods: {
        handleClick() {
            this.$emit('handleClick')
        }
    }

}
</script>

<style scoped>
.p-relative {
    position: relative;
}

.shift-top {
    position: relative;
    top: -44px;
}

.b-details {
    margin-top: -20px
}

.business-logo {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.12) !important;
}
</style>
